import {autoserializeAs} from "dcerialize";

export class ReferenceTechnology {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly name: string;
}
